import * as React from 'react';

const SvgConnectionRequest = (props) => (
  <svg
    width={36}
    height={36}
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <path
        d="M26 0H10C4.47715 0 0 4.47715 0 10V26C0 31.5228 4.47715 36 10 36H26C31.5228 36 36 31.5228 36 26V10C36 4.47715 31.5228 0 26 0Z"
        fill="url(#paint0_linear_30807_5956)"
      />
      <g opacity={0.96}>
        <g opacity={0.96} filter="url(#filter0_d_30807_5956)">
          <path
            opacity={0.96}
            d="M18 29.5C23.2467 29.5 27.5 25.2467 27.5 20C27.5 14.7533 23.2467 10.5 18 10.5C12.7533 10.5 8.5 14.7533 8.5 20C8.5 25.2467 12.7533 29.5 18 29.5Z"
            stroke="#FFD089"
            strokeWidth={4}
          />
        </g>
      </g>
      <g filter="url(#filter1_d_30807_5956)">
        <path
          opacity={0.599}
          d="M18 16C20.7614 16 23 13.7614 23 11C23 8.23858 20.7614 6 18 6C15.2386 6 13 8.23858 13 11C13 13.7614 15.2386 16 18 16Z"
          fill="white"
        />
      </g>
      <g filter="url(#filter2_d_30807_5956)">
        <path
          opacity={0.602}
          d="M10 29C12.7614 29 15 26.7614 15 24C15 21.2386 12.7614 19 10 19C7.23858 19 5 21.2386 5 24C5 26.7614 7.23858 29 10 29Z"
          fill="white"
        />
      </g>
      <g filter="url(#filter3_d_30807_5956)">
        <path
          opacity={0.599}
          d="M27 29C29.7614 29 32 26.7614 32 24C32 21.2386 29.7614 19 27 19C24.2386 19 22 21.2386 22 24C22 26.7614 24.2386 29 27 29Z"
          fill="white"
        />
      </g>
      <g opacity={0.96}>
        <path
          opacity={0.96}
          d="M10 27C11.6569 27 13 25.6569 13 24C13 22.3431 11.6569 21 10 21C8.34315 21 7 22.3431 7 24C7 25.6569 8.34315 27 10 27Z"
          fill="white"
        />
      </g>
      <g opacity={0.96}>
        <path
          opacity={0.96}
          d="M27 27C28.6569 27 30 25.6569 30 24C30 22.3431 28.6569 21 27 21C25.3431 21 24 22.3431 24 24C24 25.6569 25.3431 27 27 27Z"
          fill="white"
        />
      </g>
      <g opacity={0.96}>
        <path
          opacity={0.96}
          d="M18 14C19.6569 14 21 12.6569 21 11C21 9.34315 19.6569 8 18 8C16.3431 8 15 9.34315 15 11C15 12.6569 16.3431 14 18 14Z"
          fill="white"
        />
      </g>
    </g>
    <defs>
      <filter
        id="filter0_d_30807_5956"
        x={0.5}
        y={5.5}
        width={35}
        height={35}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={3} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_30807_5956"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_30807_5956"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_d_30807_5956"
        x={7}
        y={3}
        width={22}
        height={22}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={3} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_30807_5956"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_30807_5956"
          result="shape"
        />
      </filter>
      <filter
        id="filter2_d_30807_5956"
        x={-1}
        y={16}
        width={22}
        height={22}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={3} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_30807_5956"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_30807_5956"
          result="shape"
        />
      </filter>
      <filter
        id="filter3_d_30807_5956"
        x={16}
        y={16}
        width={22}
        height={22}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={3} />
        <feGaussianBlur stdDeviation={3} />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.161 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_30807_5956"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_30807_5956"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_30807_5956"
        x1={0}
        y1={0}
        x2={43.2}
        y2={14.436}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F0AD48" />
        <stop offset={1} stopColor="#FF9900" />
      </linearGradient>
      <clipPath>
        <rect width={36} height={36} fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default SvgConnectionRequest;
